exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img.img-fluid.img-logo{height:50px!important}i.fa.fa-user{font-size:20px}.quick-support{background:#000!important}.quick-support:after{border-color:#000 transparent transparent!important}", ""]);

// exports
